import { render } from "./recruiterActivity.vue?vue&type=template&id=4215c4ee&scoped=true"
import script from "./recruiterActivity.vue?vue&type=script&lang=js"
export * from "./recruiterActivity.vue?vue&type=script&lang=js"

import "./recruiterActivity.vue?vue&type=style&index=0&id=4215c4ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4215c4ee"]])

export default __exports__